import { base64StringToBlob } from "blob-util";

export async function stringToArrayBuffer(stringObj: string): Promise<ArrayBuffer> {
  return base64StringToBlob(stringObj, 'image/jpg').arrayBuffer();
}
